import Rate from "rc-rate";
import "rc-rate/assets/index.css";
import { useState } from "react";
import Swal from "sweetalert2";
import { FaRegStar } from "react-icons/fa";
import logo from "assets/images/sitelogo.svg";
import { toast } from "react-hot-toast";
import toastFunction from "utils/toast";
// datepicker
import persian from "react-date-object/calendars/persian";
import { DateObject } from "react-multi-date-picker";
import sendRequest from "hooks/useAxios";
import { BsTrashFill } from "react-icons/bs";
import { useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";

function CreateComment({ productId, setUpdater, type, businessId }) {
  const [submitComment, setSubmitComment] = useState({
    title: "",
    rating: "",
    txtcm: "",
    // product_id: "",
    // businessId: "",
  });
  const auth = useContext(WithAuthentication);
  const changeHandler = (value, type) => {
    setSubmitComment((prev) => {
      return { ...prev, [type]: value };
    });
  };
  const addComment = () => {
    if (auth.userInfo.userType == -1) {
      toastFunction("error", "برای ثبت نظر ابتدا لاگین کنید.");
    } else {
      if (submitComment.title == "" || submitComment.txtcm == "") {
        toastFunction("error", "لطفا تمامی مقادیر را پر کنید.");

        return false;
      }

      sendRequest("addcomment", {
        ...submitComment,
        mtm: Math.round(new Date().getTime() / 1000),
        product_id: productId,
        businessId: businessId,
        muid: auth.userInfo.id,
      }).then(({ data }) => {
        if (data.status == 1) {
          Swal.fire({
            icon: "success",
            title: "ثبت شد!",
          });
          setUpdater((prev) => {
            return !prev;
          });
          setSubmitComment({
            title: "",
            rating: "",
            txtcm: "",
            product_id: "",
            businessId: "",
            description: "",
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "خطا!",
            text: "   مشکلی در اضافه شدن کامنت به وجود آمده است",
          });
        }
      });
    }
  };
  // console.log(`productId:${productId}//businessId:${businessId}`);
  // console.log("submitComment", submitComment);

  return (
    <>
      <form className="mx-auto comments">
        <div className="d-flex my-4 comment-title-rate">
          <div className=" w-50 comment-title">
            <label className="mb-2">عنوان نظر:</label>
            <input
              className="shadow form-control p-2"
              value={submitComment.title}
              onChange={(e) => {
                changeHandler(e.target.value, "title");
              }}
              required
            ></input>
          </div>

          <div className="mx-auto align-self-center">
            امتیاز:
            <Rate
              direction="rtl"
              style={{ fontSize: 30 }}
              defaultValue={2.5}
              allowHalf={true}
              value={submitComment.rating}
              onChange={(r) => {
                changeHandler(r, "rating");
              }}
            ></Rate>
          </div>
        </div>

        <div className=" my-4">
          <label className="mb-2">شرح نظر:</label>
          <textarea
            className="shadow form-control p-3"
            style={{ width: "90%" }}
            value={submitComment.txtcm}
            onChange={(e) => {
              changeHandler(e.target.value, "txtcm");
            }}
            required
          ></textarea>
          <div className={`validation-txt ${0 == true ? "d-block" : "d-none"}`}>
            فیلد شرح نظر نباید خالی باشد.
          </div>
        </div>
        <div className="d-flex">
          <button
            type="button"
            onClick={addComment}
            className="btn btn-color text-light ms-auto me-5 my-2"
          >
            ثبت نظر
          </button>
        </div>
      </form>
    </>
  );
}
const deleteComment = (id, setUpdater) => {
  Swal.fire({
    title: "کامنت مد نظر حذف شود؟",
    // text: "You won't be able to revert this!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "حذف",
    cancelButtonText: "انصراف",
  }).then((result) => {
    if (result.isConfirmed) {
      sendRequest("Delete_comments", { conditions: `id/=/${id}` }).then(
        ({ data }) => {
          if (data.status == 1) {
            Swal.fire("حذف شد", "", "success");
            setUpdater((prev) => {
              return !prev;
            });
          } else {
            Swal.fire("مشکلی پیش آمده است.", "", "error");
          }
        }
      );
    }
  });
};
function CommentList({ commentLists, setUpdater }) {
  const auth = useContext(WithAuthentication);

  return (
    <>
      {commentLists.map((Value) => {
        const calculateTime = () => {
          const currentTime = new Date().getTime();
          const x = Math.round(currentTime / 1000) - parseInt(Value.mtm);
          const y = x / 3600;
          const z = Math.round(y);
          if (z >= 0 && z <= 1) {
            return " کمتر از یک ساعت قبل";
          } else if (z > 1 && z < 24) {
            return `${z} ساعت قبل`;
          } else if (z < 168 && z >= 24) {
            const a = z / 24;
            const b = Math.round(a);
            return `${b} روز قبل`;
          } else if (z >= 168) {
            const a = Value.tmt * 1000;
            const date = new DateObject({ date: a, calendar: persian });
            const b = new Date(a);
            return date.format();
          }
        };
        return (
          <div className=" card comment-list mx-auto my-4 shadow">
            <div className="card-header fs-14 d-flex justify-content-between bg-color-blue text-light round-top">
              <div className="ms-4">
                {auth.userInfo.userType == 0 ? (
                  // ||auth.userInfo.id == +Value.muid
                  <span
                    onClick={() => {
                      deleteComment(Value.id, setUpdater);
                    }}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      fontSize: "15px",
                    }}
                  >
                    <BsTrashFill></BsTrashFill>
                  </span>
                ) : null}
                {Value.fname != null &&
                  Value.fname + " " + Value.fname != null &&
                  Value.fname}
                {/* {+Value.isbuying && " - خریدار"} */}
              </div>
              <div className="me-3">{calculateTime()}</div>
            </div>
            <div className="card-body bg-color-gray round round-bottom">
              <div className="d-flex">
                <div className="title-style">عنوان :</div>
                <div className="ms-2">{Value.title}</div>
              </div>
              <div className="d-flex my-2">
                <div className="title-style">شرح نظر:</div>
                <div className="ms-2">{Value.txtcm}</div>
              </div>
              <div className="d-flex">
                <Rate
                  className="ms-auto"
                  disabled={true}
                  allowHalf={true}
                  direction="rtl"
                  style={{ fontSize: 20 }}
                  defaultValue={+Value.rating}

                  // onChange={(r) => {
                  //   setRate(r);
                  // }}
                ></Rate>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default CreateComment;
export { CommentList };
